import React from 'react';
import styled from 'styled-components';
import { Tag, Icon, Card as _Card } from 'antd';
import { darken } from 'polished';

import { OrangeButton } from 'components/Core/Buttons';
import { productTypeToText, getTripDuration } from 'utils/product';
import { path } from 'utils/media';

const Card = styled(_Card)`
  width: 100%;
  .ant-card-body {
    padding: 16px 24px;
  }
`;

const ProductImage = styled.img`
  display: block;
  width: 100%;
  align-self: center;
  height: 220px;
  object-fit: cover;
  @media(max-width: 768px) {
    width: 100%;
    height: 200px;
    margin-bottom: 10px;
  }
`;

const Star = styled(Icon).attrs({
  type: props => (props.active ? 'star' : 'star-o')
})`
  font-size: 32px;
  margin-left: 8px;
  color: #F3AC2A;
  cursor: pointer;
`;

const TripName = styled.h3`
  cursor: pointer;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  &:hover {
    color: ${props => darken(0.1, props.theme.orange)};
  }
`;

const StartTime = styled.p`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
`;

const TagContainer = styled.div`
  margin: 6px 0 10px;
`;

const ProductTypeTag = styled(Tag).attrs({
  color: props => props.theme.blue
})`
  cursor: default;
  font-family: Montserrat !important;
`;

const ProductTag = styled(Tag)`
  cursor: default;
  margin-right: 5px;
  font-family: Montserrat !important;
  border-color: ${props => props.theme.blue} !important;
  color: ${props => props.theme.blue} !important;
  background-color: ${props => props.theme.white} !important;
  margin-bottom: 4px;
`;

const BookContainer = styled.div`
  display: flex;
  align-items: center;
`;

const BookButton = styled(OrangeButton)`
  font-size: 12px !important;
  width: 100%;
  height: 30px;
`;

const ProductItem = props => {
  const { item, onSelect, isInWishlist } = props;
  return (
    <Card
      hoverable
      cover={<ProductImage src={path(item.cover_image, 'rectangle-620-466')} alt={item.name} />}
    >
      <TripName onClick={onSelect}>{item.name}</TripName>
      {item.product_type === 'trip' && item.itinerary && <StartTime>Start at {item.itinerary[0].time}</StartTime>}
      <TagContainer>
        <ProductTypeTag>{productTypeToText(item.product_type)}</ProductTypeTag>
        {item.destination_location && <ProductTag>{item.destination_location}</ProductTag>}
        {item.duration && item.product_type === 'trip' && <ProductTag>{getTripDuration(item)} hr</ProductTag>}
        {item.transportation === 'Private Car' && item.product_type === 'trip' && <ProductTag>Private Car</ProductTag>}
      </TagContainer>
      <BookContainer>
        <BookButton onClick={onSelect}>Book</BookButton>
        <Star onClick={props.onToggleWishlist} active={isInWishlist} />
      </BookContainer>
    </Card>
  );
};

export default ProductItem;



// WEBPACK FOOTER //
// ./src/components/Product/ProductItem.js